import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../AxiosInstance";
import toast from "react-hot-toast";

const VerifyPasswordChange = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (token) {
      axios
        .get(`api/v1/admin/verify-password-change?token=${token}`)
        .then((res) => {
          navigate("/");
          toast.success(res.data.message);
        })
        .catch((err) => {
          toast.error(
            err.response?.data?.message ||
              "Token verification failed. Please try again."
          );
        });
    } else {
      toast.error("Token not found in URL.");
    }
  }, [location.search]);

  return <div>Password Change verification in progress...</div>;
};

export default VerifyPasswordChange;
